import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>📸 Photo-Gram</h1>
      <h2>Collect Moments ✨</h2>
      <p>Capturing The Memories Of Today That Will WoW Your Hearts Tomorrow.</p>
    </div>
  )
}

export default Title;